import { useEffect } from 'react';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { pathOr } from 'ramda';

import { GET_FILTER_VALUES, Filters } from './PlacesFilters.queries';

type TableFilters = {
  data: Filters;
};

const defaultFilters = {
  data: {
    placesNameFilter: '',
    placesCityFilter: '',
    placesStateFilter: '',
  },
};

export const usePlacesFilters = () => {
  const client = useApolloClient();

  useEffect(() => {
    writeFilterCache(defaultFilters);
  }, []);

  const { data: placesFilters = {} as Filters } = useQuery<Filters>(
    GET_FILTER_VALUES,
  );

  const state = pathOr('', ['placesStateFilter'], placesFilters);

  const writeFilterCache = (filters: TableFilters) => {
    client.writeData(filters);
  };

  return {
    writeFilterCache,
    placesFilters,
    state,
  };
};
